import api from './api';
import { Contact, ContactFormData, ApiResponse } from '../../types/contacts.types';

class ContactsService {
  private readonly endpoint = '/api/contacts';

  async getAll(officeType?: string): Promise<ApiResponse<Contact[]>> {
    const params = officeType ? { office_type: officeType } : {};
    const response = await api.get<ApiResponse<Contact[]>>(this.endpoint, { params });
    return response.data;
  }

  async getHeadOfficeContacts(): Promise<ApiResponse<Contact[]>> {
    const response = await api.get<ApiResponse<Contact[]>>(`${this.endpoint}/head-office`);
    return response.data;
  }

  async getTerritoryOfficeContacts(): Promise<ApiResponse<Contact[]>> {
    const response = await api.get<ApiResponse<Contact[]>>(`${this.endpoint}/territory-office`);
    return response.data;
  }

  async getById(id: number): Promise<ApiResponse<Contact>> {
    const response = await api.get<ApiResponse<Contact>>(`${this.endpoint}/${id}`);
    return response.data;
  }

  async create(contactData: ContactFormData, imageFile?: File): Promise<ApiResponse<Contact>> {
    const formData = new FormData();
    Object.entries(contactData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, String(value));
      }
    });
    if (imageFile) {
      formData.append('image', imageFile);
    }
    const response = await api.post<ApiResponse<Contact>>(this.endpoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async update(id: number, contactData: Partial<ContactFormData>, imageFile?: File): Promise<ApiResponse<Contact>> {
    const formData = new FormData();
    Object.entries(contactData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, String(value));
      }
    });
    if (imageFile) {
      formData.append('image', imageFile);
    }
    const response = await api.put<ApiResponse<Contact>>(`${this.endpoint}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  async delete(id: number): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${this.endpoint}/${id}`);
    return response.data;
  }

  async toggleStatus(id: number): Promise<ApiResponse<Contact>> {
    const response = await api.put<ApiResponse<Contact>>(`${this.endpoint}/${id}/toggle-status`);
    return response.data;
  }

  async search(searchTerm: string, officeType?: string): Promise<ApiResponse<Contact[]>> {
    const params: any = { search: searchTerm };
    if (officeType) {
      params.office_type = officeType;
    }
    const response = await api.get<ApiResponse<Contact[]>>(this.endpoint, { params });
    return response.data;
  }
}

export const contactsService = new ContactsService();
